<div class="maintenance-mode maintenance-mode-text" *ngIf="maintenanceModeService.maintenanceMode.active">
  <div class="maintenance-mode-icon">
    <i class="fas fa-exclamation-circle fa-3x"></i>
  </div>
  <div
    [innerHTML]="
      maintenanceModeService.maintenanceMode.message
        | maintenanceModeDateTime
          : maintenanceModeService.maintenanceMode.startDate
          : maintenanceModeService.maintenanceMode.endDate
    "
  ></div>
</div>
